(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var helpers_1 = require("./helpers");
var scene_manager_1 = require("./scene_manager");
var Block = (function () {
    function Block(name, parent) {
        this.name = name;
        this.parent = parent;
        this.w = 0;
        this.h = 0;
        this.d = 0;
        this.depth = parent === null ? 0 : parent.depth + 1;
    }
    Block.prototype.getColor = function () {
        if (!this.color) {
            this.color = new THREE.Color(parseInt(helpers_1.colorLuminance(this.parent.getColor().getHex(), 0.3).substring(1).toUpperCase(), 16));
        }
        return this.color;
    };
    Block.prototype.setColor = function (color) {
        this.color = new THREE.Color(color);
    };
    Block.prototype.getX = function () {
        return (this.parent === null) ? this.fit.x : this.parent.getX() + this.fit.x;
    };
    Block.prototype.getY = function () {
        return (this.parent === null) ? this.fit.y : this.parent.getY() + this.fit.y;
    };
    Block.prototype.getTrackerText = function () {
        return this.name;
    };
    return Block;
}());
exports.Block = Block;
var Building = (function (_super) {
    __extends(Building, _super);
    function Building(parent, data, heightLevels, widthLevels, heightAttr, widthAttr) {
        _super.call(this, data.name, parent);
        this.parent = parent;
        this.data = data;
        this.heightLevels = heightLevels;
        this.widthLevels = widthLevels;
        this.heightAttr = heightAttr;
        this.widthAttr = widthAttr;
        this.calculateBlockWidth(widthAttr, widthLevels);
        this.calculateBlockHeight(heightAttr, heightLevels);
    }
    Building.prototype.calculateBlockWidth = function (widthAttr, widthLevels) {
        for (var i = 0; i < 5; i++) {
            if (this.data[widthAttr] <= widthLevels[i]) {
                this.w = (i * 2 + 2) + 2;
                this.h = (i * 2 + 2) + 2;
                break;
            }
        }
    };
    Building.prototype.calculateBlockHeight = function (heightAttr, heightLevels) {
        for (var i = 0; i < 5; i++) {
            if (this.data[heightAttr] <= heightLevels[i]) {
                this.d = (i + 1) * 4;
                break;
            }
        }
    };
    Building.prototype.render = function (scene, depth) {
        var options = { color: 0x2f9dbd };
        if (this.data.abstract) {
            options.color = 0x2fbdab;
            options.opacity = 0.5;
            options.transparent = true;
        }
        else if (this.data.type === "interface") {
            options.color = 0x3c2fbd;
        }
        var geometry = new THREE.BoxGeometry(1, 1, 1);
        var material = new THREE.MeshBasicMaterial(options);
        material.defaultColor = options.color;
        material.originalColor = options.color;
        geometry.applyMatrix(new THREE.Matrix4().makeTranslation(0.5, 0.5, 0.5));
        var mesh = new THREE.Mesh(geometry, material);
        mesh.name = this.name ? this.name : '';
        mesh.position.set(this.getX() - 1 * this.parent.addWidth + 1, 0 + depth / 2 + depth * 0.05, this.getY() - 1 * this.parent.addWidth + 1);
        mesh.scale.set(this.w - 2, this.d, this.h - 2);
        mesh.block = this;
        var edges = new THREE.EdgesHelper(mesh, 0x000000);
        mesh.edges = edges;
        scene_manager_1.SceneManager.objects.push(mesh);
        scene.add(mesh);
        scene.add(edges);
    };
    Building.prototype.getTrackerText = function () {
        var text = "<em>&lt;&lt; " + this.data.type + " &gt;&gt;</em><br><strong>" + this.name + "</strong><br>";
        if (this.data.extends !== null) {
            text += " extends <em>" + this.data.extends + "</em><br>";
        }
        if (this.data.implements !== null) {
            text += " implements <em>" + this.data.implements + "</em><br>";
        }
        return text + ("<br>Package: " + this.parent.getQualifiedName() + "<br><br>Methods: " + this.data.no_methods + "<br>Attributes: " + this.data.no_attrs + "<br>LOC: " + this.data.no_lines + "<br><br>File: " + this.data.file);
    };
    return Building;
}(Block));
exports.Building = Building;
var District = (function (_super) {
    __extends(District, _super);
    function District(name, height, parent) {
        _super.call(this, name, parent);
        this.children = [];
        this.buildings = [];
        this.d = height;
    }
    District.prototype.render = function (scene, depth) {
        var color = this.getColor().getHex();
        var geometry = new THREE.BoxGeometry(1, 1, 1);
        var material = new THREE.MeshBasicMaterial({ color: color });
        material.defaultColor = material.originalColor = color;
        geometry.applyMatrix(new THREE.Matrix4().makeTranslation(0.5, 0.5, 0.5));
        var mesh = new THREE.Mesh(geometry, material);
        mesh.name = this.name ? this.name : '';
        mesh.position.set(this.getX() - 1 * this.addWidth, 0 + depth / 2 + depth * 0.05, this.getY() - 1 * this.addWidth);
        mesh.scale.set(this.w - 2, this.d / 2, this.h - 2);
        var edges = new THREE.EdgesHelper(mesh, 0x000000);
        mesh.edges = edges;
        scene.add(mesh);
        scene.add(edges);
        scene_manager_1.SceneManager.objects.push(mesh);
        mesh.block = this;
        _.each(this.children, function (e) { return e.render(scene, depth + 1); });
        _.each(this.buildings, function (e) { return e.render(scene, depth + 1); });
    };
    District.prototype.getWidth = function () {
        var packer = new GrowingPacker();
        if (this.children.length === 0) {
            var l = this.buildings.length;
            var sorted = _.sortBy(this.buildings, function (e) { return e.w; }).reverse();
            packer.fit(sorted);
            this.w = packer.root.w + 2;
            this.h = packer.root.h + 2;
            this.fit = packer.root;
            for (var i = 0; i < sorted.length; i++) {
                var block = sorted[i];
                for (var j = 0; j < l; j++) {
                    if (this.buildings[j].data.file === block.data.file) {
                        this.buildings[j].fit = block.fit;
                    }
                }
            }
        }
        else if (this.children.length != 0) {
            var l = this.children.length;
            for (var i = 0; i < l; i++) {
                this.childrenWidth();
            }
            var sorted = _.sortBy(this.children.concat(this.buildings), function (e) { return e.w; }).reverse();
            packer.fit(sorted);
            this.w = packer.root.w + 2;
            this.h = packer.root.h + 2;
            this.fit = packer.root;
            for (var i = 0; i < sorted.length; i++) {
                var block = sorted[i];
                for (var j = 0; j < this.buildings.length; j++) {
                    if (block instanceof Building && this.buildings[j].data.file === block.data.file) {
                        this.buildings[j].fit = block.fit;
                    }
                }
            }
        }
        return this.w;
    };
    District.prototype.childrenWidth = function () {
        var l = this.children.length;
        var width = 0;
        for (var i = 0; i < l; i++) {
            width += this.children[i].getWidth();
        }
        return width;
    };
    District.prototype.addBuilding = function (building) {
        this.buildings.push(building);
    };
    District.prototype.addChildDistrict = function (district) {
        this.children.push(district);
    };
    District.prototype.getQualifiedName = function () {
        if (this.parent === null) {
            return '';
        }
        if (this.name == 'none') {
            return '<em>No package</em>';
        }
        return this.parent.getQualifiedName() + "\\" + this.name;
    };
    District.prototype.getChildBuildingsCount = function () {
        var sum = _.reduce(this.children, function (memo, e) { return memo + e.getChildBuildingsCount(); }, 0);
        return sum + this.buildings.length;
    };
    District.prototype.getTrackerText = function () {
        if (this.depth == 0) {
            return "<em>City base</em><br><em>Buildings:</em>" + this.getChildBuildingsCount();
        }
        return "<em>Package:</em><strong>" + this.getQualifiedName() + "</strong><br><em>Buildings:</em>" + this.getChildBuildingsCount();
    };
    return District;
}(Block));
exports.District = District;
},{"./helpers":2,"./scene_manager":7}],2:[function(require,module,exports){
"use strict";
function colorLuminance(hex, lum) {
    var hex_string = ('000000' + hex.toString(16)).slice(-6);
    var rgb = "#";
    lum = lum || 0;
    for (var i = 0; i < 3; i++) {
        var num_color = parseInt(hex_string.substr(i * 2, 2), 16);
        var str_color = Math.round(Math.min(Math.max(0, num_color + (num_color * lum)), 255)).toString(16);
        rgb += ("00" + str_color).substr(str_color.length);
    }
    return rgb;
}
exports.colorLuminance = colorLuminance;
},{}],3:[function(require,module,exports){
"use strict";
function histogram(values, id) {
    var formatCount = d3.format(",.0f");
    var margin = { top: 20, right: 30, bottom: 20, left: 30 }, width = 460 - margin.left - margin.right, height = 220 - margin.top - margin.bottom;
    var x = d3.scale.linear()
        .domain([0, d3.max(values, function (d) { return d; })])
        .range([0, width]);
    var data = d3.layout.histogram().bins(x.ticks(30))(values);
    var y = d3.scale.linear()
        .domain([0, d3.max(data, function (d) { return d.y; })])
        .range([height, 0]);
    var xAxis = d3.svg.axis()
        .scale(x)
        .orient("bottom");
    var svg = d3.select(id).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    var bar = svg.selectAll(".bar")
        .data(data)
        .enter().append("g")
        .attr("class", "bar")
        .attr("transform", function (d) { return "translate(" + x(d.x) + "," + y(d.y) + ")"; });
    bar.append("rect")
        .attr("x", 1)
        .attr("width", x(data[0].dx) - 1)
        .attr("height", function (d) { return height - y(d.y); });
    bar.append("text")
        .attr("dy", ".75em")
        .attr("y", 6)
        .attr("x", x(data[0].dx) / 2)
        .attr("text-anchor", "middle")
        .text(function (d) { return formatCount(d.y); });
    svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);
}
exports.histogram = histogram;
},{}],4:[function(require,module,exports){
"use strict";
},{}],5:[function(require,module,exports){
"use strict";
var scene_manager_1 = require("./scene_manager");
var preprocessor_1 = require('./preprocessor');
var blocks_1 = require('./blocks');
$(document).ready(function () {
    scene_manager_1.SceneManager.initialize();
    $("input[type=file]").on('change', function (e) { return preprocessor_1.processJSONInput(e.target); });
    $('input[name="filter-type"]').on('change', function (e) {
        var val = $('input[name="filter-type"]:checked').val();
        var l = scene_manager_1.SceneManager.objects.length;
        for (var i = 0; i < l; i++) {
            var block = scene_manager_1.SceneManager.objects[i].block;
            if (block instanceof blocks_1.Building) {
                scene_manager_1.SceneManager.determineVisibility(scene_manager_1.SceneManager.objects[i], block, val);
            }
        }
    });
    $('#class-extends').on('change', function (e) {
        $('#class-implements').val('');
        var val = $('#class-extends').val();
        var l = scene_manager_1.SceneManager.objects.length;
        for (var i = 0; i < l; i++) {
            var object = scene_manager_1.SceneManager.objects[i];
            var block = scene_manager_1.SceneManager.objects[i].block;
            if (block instanceof blocks_1.Building) {
                object.material.color.setHex(block.data.extends == val ? 0xeead12 : (object.material.defaultColor == 0xeead12 ? object.material.originalColor : object.material.defaultColor));
                object.material.defaultColor = block.data.extends == val ? 0xeead12 : object.material.originalColor;
            }
        }
    });
    $('#class-implements').on('change', function (e) {
        $('#class-extends').val('');
        var val = $('#class-implements').val();
        var l = scene_manager_1.SceneManager.objects.length;
        for (var i = 0; i < l; i++) {
            var object = scene_manager_1.SceneManager.objects[i];
            var block = scene_manager_1.SceneManager.objects[i].block;
            if (block instanceof blocks_1.Building) {
                object.material.color.setHex(block.data.implements == val ? 0xeead12 : (object.material.defaultColor == 0xeead12 ? object.material.originalColor : object.material.defaultColor));
                object.material.defaultColor = block.data.implements == val ? 0xeead12 : object.material.originalColor;
            }
        }
    });
    $('#settings-form').on('submit', function (e) {
        e.preventDefault();
        scene_manager_1.SceneManager.preprocessor.processJSON();
    });
    $('#demo-project-select').on('change', function (e) {
        var projectName = $('#demo-project-select').val();
        $.getJSON("./data/" + projectName + ".json", function (data) {
            var preprocessor = new preprocessor_1.Preprocessor(data);
            scene_manager_1.SceneManager.preprocessor = preprocessor;
            preprocessor.processJSON(projectName);
        });
    });
});
},{"./blocks":1,"./preprocessor":6,"./scene_manager":7}],6:[function(require,module,exports){
"use strict";
var blocks_1 = require('./blocks');
var scene_manager_1 = require('./scene_manager');
var histogram_1 = require('./histogram');
function processJSONInput(input) {
    var reader = new FileReader();
    reader.onload = function (evt) {
        var json;
        try {
            json = JSON.parse(evt.target.result);
        }
        catch (e) {
            alert('Could not parse input file. Did you upload valid JSON?');
            return;
        }
        var preprocessor = new Preprocessor(json);
        scene_manager_1.SceneManager.preprocessor = preprocessor;
        preprocessor.processJSON($(input).get(0).files[0].name.split('.')[0]);
    };
    reader.readAsText($(input).get(0).files[0], 'UTF-8');
}
exports.processJSONInput = processJSONInput;
var Preprocessor = (function () {
    function Preprocessor(json) {
        this.json = json;
        this.heightLevels = [];
        this.widthLevels = [];
        this.jsonLength = json.length;
    }
    Preprocessor.prototype.processJSON = function (fileName) {
        scene_manager_1.SceneManager.cleanUp();
        this.widthType = $('input[name="width-type"]:checked').val();
        this.heightType = $('input[name="height-type"]:checked').val();
        this.widthAttr = $('#width-attribute').val();
        this.heightAttr = $('#height-attribute').val();
        if (fileName) {
            $('#project-name').text(fileName);
        }
        $('#project-objects').text(this.json.length);
        this.city = {
            districts: { base: new blocks_1.District('base', 1, null) },
            buildings: []
        };
        this.detectLevels();
        this.buildCity();
        var buildingCount = this.city.buildings.length;
        var districtsCount = _.size(this.city.districts);
        var base = this.city.districts['base'];
        this.city.districts['base'].setColor(0x0e4467);
        var maxDepth = _.max(this.city.districts, function (e) { return e.depth; }).depth;
        _.each(this.city.districts, function (e) { return e.addWidth = maxDepth - e.depth; });
        base.getWidth();
        base.render(scene_manager_1.SceneManager.scene, 0);
        var _extends = _.countBy(this.city.buildings, function (e) { return e.data.extends; });
        delete _extends['null'];
        var _implements = _.countBy(this.city.buildings, function (e) { return e.data.implements; });
        delete _implements['null'];
        var eKeys = Object.keys(_extends).sort();
        var iKeys = Object.keys(_implements).sort();
        $('#class-extends').find('option').remove().end().append('<option>-</option>').val('');
        for (var i = 0; i < eKeys.length; i++) {
            $('<option/>').val(eKeys[i]).html('(' + _extends[eKeys[i]] + ') ' + eKeys[i]).appendTo('#class-extends');
        }
        $('#class-implements').find('option').remove().end().append('<option>-</option>').val('');
        for (var i = 0; i < iKeys.length; i++) {
            $('<option/>').val(iKeys[i]).html('(' + _implements[iKeys[i]] + ') ' + iKeys[i]).appendTo('#class-implements');
        }
    };
    Preprocessor.prototype.detectLevels = function () {
        var sorted = _.sortBy(this.json, this.heightAttr);
        var sorted_length = sorted.length;
        var json_length = this.json.length;
        if (this.heightType == "evenly") {
            this.heightLevels = [
                sorted[Math.floor(json_length / 5)][this.heightAttr],
                sorted[Math.floor(json_length / 5 * 2)][this.heightAttr],
                sorted[Math.floor(json_length / 5 * 3)][this.heightAttr],
                sorted[Math.floor(json_length / 5 * 4)][this.heightAttr],
                sorted[sorted_length - 1][this.heightAttr],
            ];
        }
        else {
            this.heightLevels = [
                Math.floor(sorted[sorted_length - 1][this.heightAttr] / 5),
                Math.floor(sorted[sorted_length - 1][this.heightAttr] / 4),
                Math.floor(sorted[sorted_length - 1][this.heightAttr] / 3),
                Math.floor(sorted[sorted_length - 1][this.heightAttr] / 2),
                Math.floor(sorted[sorted_length - 1][this.heightAttr] / 1),
            ];
        }
        for (var i_1 = 1; i_1 < sorted_length; i_1++) {
            if (this.heightLevels[i_1] == this.heightLevels[i_1 - 1]) {
                this.heightLevels[i_1]++;
            }
            else if (this.heightLevels[i_1] < this.heightLevels[i_1 - 1]) {
                this.heightLevels[i_1] = this.heightLevels[i_1 - 1] + 1;
            }
            else if (!this.heightLevels[i_1]) {
                break;
            }
        }
        sorted = _.sortBy(this.json, this.widthAttr);
        if (this.widthType == "evenly") {
            this.widthLevels = [
                sorted[Math.floor(json_length / 5)][this.widthAttr],
                sorted[Math.floor(json_length / 5 * 2)][this.widthAttr],
                sorted[Math.floor(json_length / 5 * 3)][this.widthAttr],
                sorted[Math.floor(json_length / 5 * 4)][this.widthAttr],
                sorted[sorted_length - 1].no_attrs,
            ];
        }
        else {
            this.widthLevels = [
                Math.floor(sorted[sorted_length - 1][this.widthAttr] / 5),
                Math.floor(sorted[sorted_length - 1][this.widthAttr] / 4),
                Math.floor(sorted[sorted_length - 1][this.widthAttr] / 3),
                Math.floor(sorted[sorted_length - 1][this.widthAttr] / 2),
                Math.floor(sorted[sorted_length - 1][this.widthAttr] / 1),
            ];
        }
        for (var i = 1; i < sorted.length; i++) {
            if (this.widthLevels[i] == this.widthLevels[i - 1]) {
                this.widthLevels[i]++;
            }
            else if (this.widthLevels[i] < this.widthLevels[i - 1]) {
                this.widthLevels[i] = this.widthLevels[i - 1] + 1;
            }
            else if (!this.widthLevels[i]) {
                break;
            }
        }
    };
    Preprocessor.prototype.buildCity = function () {
        for (var i = 0; i < this.jsonLength; i++) {
            this.createBlock(this.json[i]);
        }
        $('#histogram-loc, #histogram-attributes, #histogram-methods').html('');
        histogram_1.histogram(_.pluck(this.json, 'no_lines'), '#histogram-loc');
        histogram_1.histogram(_.pluck(this.json, 'no_attrs'), '#histogram-attributes');
        histogram_1.histogram(_.pluck(this.json, 'no_methods'), '#histogram-methods');
    };
    Preprocessor.prototype.createBlock = function (obj) {
        var currentDistrict = this.buildDistricts(obj.namespace);
        var building = new blocks_1.Building(currentDistrict, obj, this.heightLevels, this.widthLevels, this.heightAttr, this.widthAttr);
        currentDistrict.addBuilding(building);
        this.city.buildings.push(building);
    };
    Preprocessor.prototype.buildDistricts = function (namespace) {
        var parentDistrict = this.city.districts['base'];
        if (!namespace || namespace === '') {
            return this.findOrCreateDistrict('none', 1, parentDistrict);
        }
        var districtNames = namespace.split('\\');
        var length = districtNames.length;
        for (var i = 0; i < length; i++) {
            var district = this.findOrCreateDistrict(districtNames[i], 1, parentDistrict);
            parentDistrict = district;
        }
        return district;
    };
    Preprocessor.prototype.findOrCreateDistrict = function (name, height, parent) {
        if (this.city.districts[name] !== undefined) {
            return this.city.districts[name];
        }
        var district = new blocks_1.District(name, height, parent);
        this.city.districts[name] = district;
        parent.addChildDistrict(district);
        return district;
    };
    return Preprocessor;
}());
exports.Preprocessor = Preprocessor;
},{"./blocks":1,"./histogram":3,"./scene_manager":7}],7:[function(require,module,exports){
"use strict";
var stats_1 = require("./stats");
var SceneManager = (function () {
    function SceneManager() {
    }
    SceneManager.cleanUp = function () {
        for (var _i = 0, _a = this.objects; _i < _a.length; _i++) {
            var obj = _a[_i];
            SceneManager.scene.remove(obj);
            SceneManager.scene.remove(obj.edges);
            obj.edges.geometry.dispose();
            obj.edges.material.dispose();
            obj.geometry.dispose();
            obj.material.dispose();
        }
        SceneManager.objects = [];
    };
    SceneManager.initialize = function () {
        SceneManager.init();
        SceneManager.animate();
    };
    SceneManager.init = function () {
        var width = window.innerWidth;
        var height = window.innerHeight;
        SceneManager.renderer = new THREE.WebGLRenderer({ antialias: true, canvas: document.getElementById('canvas') });
        SceneManager.renderer.setClearColor(0xcccccc, 1);
        SceneManager.renderer.setSize(width, height);
        SceneManager.renderer.domElement.addEventListener('mousemove', SceneManager.onDocumentMouseMove, false);
        document.body.appendChild(SceneManager.renderer.domElement);
        SceneManager.camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 10000000);
        SceneManager.camera.position.set(70, 70, 150);
        SceneManager.scene.add(SceneManager.camera);
        SceneManager.scene.add(new THREE.AmbientLight(0xcccccc));
        window.addEventListener('resize', function () {
            var width = window.innerWidth;
            var height = window.innerHeight;
            SceneManager.renderer.setSize(width, height);
            SceneManager.camera.aspect = width / height;
            SceneManager.camera.updateProjectionMatrix();
        });
        SceneManager.controls = new THREE.OrbitControls(SceneManager.camera, SceneManager.renderer.domElement);
    };
    SceneManager.animate = function () {
        requestAnimationFrame(SceneManager.animate);
        SceneManager.renderer.render(SceneManager.scene, SceneManager.camera);
        SceneManager.controls.update();
        stats_1.stats.update();
    };
    SceneManager.determineVisibility = function (mesh, building, val) {
        switch (val) {
            case 'all':
                mesh.visible = mesh.edges.visible = true;
                break;
            case 'abstract':
                mesh.visible = mesh.edges.visible = building.data.abstract;
                break;
            case 'final':
                mesh.visible = mesh.edges.visible = building.data.final;
                break;
            case 'interface':
                mesh.visible = mesh.edges.visible = building.data.type === 'interface';
                break;
            case 'trait':
                mesh.visible = mesh.edges.visible = building.data.trait;
                break;
        }
    };
    SceneManager.onDocumentMouseMove = function (event) {
        event.preventDefault();
        var intersectColor = 0x00D66B;
        var coords = {
            x: (event.clientX / window.innerWidth) * 2 - 1,
            y: -(event.clientY / window.innerHeight) * 2 + 1
        };
        SceneManager.raycaster.setFromCamera(coords, SceneManager.camera);
        var intersections = SceneManager.raycaster.intersectObjects(SceneManager.objects);
        var tracker = $('#tracker');
        if (intersections.length > 0) {
            if (SceneManager.intersectedBlock != intersections[0].object) {
                if (SceneManager.intersectedBlock)
                    SceneManager.intersectedBlock.material.color.setHex(SceneManager.intersectedBlock.material.defaultColor);
                SceneManager.intersectedBlock = intersections[0].object;
                SceneManager.intersectedBlock.material.color.setHex(intersectColor);
                tracker.html(SceneManager.intersectedBlock.block.getTrackerText());
            }
            tracker.css({ top: (event.clientY + 10) + "px", left: (event.clientX + 10) + "px", display: 'block' });
            document.body.style.cursor = 'pointer';
        }
        else if (SceneManager.intersectedBlock) {
            SceneManager.intersectedBlock.material.color.setHex(SceneManager.intersectedBlock.material.defaultColor);
            SceneManager.intersectedBlock = null;
            tracker.css('display', 'none');
            document.body.style.cursor = 'auto';
        }
    };
    SceneManager.objects = [];
    SceneManager.scene = new THREE.Scene();
    SceneManager.raycaster = new THREE.Raycaster();
    return SceneManager;
}());
exports.SceneManager = SceneManager;
},{"./stats":8}],8:[function(require,module,exports){
"use strict";
exports.stats = new Stats();
exports.stats.showPanel(0);
exports.stats.dom.style.position = 'absolute';
exports.stats.dom.style.top = 'auto';
exports.stats.dom.style.left = 'auto';
exports.stats.dom.style.right = '2px';
exports.stats.dom.style.bottom = '26px';
document.body.appendChild(exports.stats.dom);
},{}]},{},[1,2,3,4,5,6,7,8])

